import {Button} from 'antd';
import dayjs from 'dayjs';
import html2pdf from 'html2pdf.js';
import PropTypes from 'prop-types';
import  {useRef} from 'react';

const InvoiceScreen = ({selectedOrderSummary, setSelectedOrderSummary, setOpenInvoiceModal}) => {
  const invoiceRef = useRef(null);

  const orderSummary = selectedOrderSummary || {};

  console.log('orderSummary', orderSummary);

  if (!selectedOrderSummary) {
    return <div>No invoice data available.</div>;
  }

  const handleDownloadPDF = () => {
    const element = invoiceRef.current;
    const opt = {
      margin: 0,
      filename: 'invoice.pdf',
      image: {type: 'jpeg', quality: 0.98},
      html2canvas: {scale: 2},
      jsPDF: {unit: 'mm', format: 'a4', orientation: 'landscape'},
    };
    html2pdf().set(opt).from(element).save();
    setSelectedOrderSummary(null);
    setOpenInvoiceModal(false);
  };

  return (
    <div className={'h-auto bg-gray-100'}>
      <div className={'max-w-3xl mx-auto mb-6 flex justify-end'}>
        <Button type={'primary'} size={'large'} className={'bg-primary-600 text-white hover:bg-primary-800'} onClick={handleDownloadPDF}>
            Download Invoice
        </Button>
      </div>
      
      <div
        ref={invoiceRef}
        className={`w-full
    max-w-[1200px]
    mx-auto
    bg-white
    shadow-md
    rounded-md
    px-8
    py-6`}
  
      >
        <div className={'flex justify-between items-center border-b pb-6 mb-6'}>
          <div>
            <h1 className={'text-3xl font-bold text-gray-800'}>Invoice</h1>
            <p className={'text-sm text-gray-500'}>Date: {dayjs(orderSummary?.createdOn,
            ).format('DD-MM-YYYY')}</p>
          </div>

        </div>
        
        <div className={'mb-8'}>
          <h2 className={'text-lg font-semibold text-gray-700 mb-2'}>Billed To:</h2>
          <p className={'text-sm text-gray-800 font-medium'}>
            {orderSummary?.userInfo?.firstName} {orderSummary?.userInfo?.lastName}
          </p>
          <p className={'text-sm text-gray-700'}>
            {[
              orderSummary?.userInfo?.apartment,
              orderSummary?.userInfo?.street,
              orderSummary?.userInfo?.district,
              orderSummary?.userInfo?.city,
              orderSummary?.userInfo?.state,
              orderSummary?.userInfo?.pinCode,
            ]
              .filter(Boolean)
              .join(', ')}
          </p>
          <p className={'text-sm text-gray-700'}>{orderSummary?.userInfo?.email}</p>
        </div>
        
        <table className={'w-full text-sm mb-8'}>
          <thead>
            <tr className={'text-gray-600 border-b'}>
              <th className={'text-left py-3 font-semibold'}>Product</th>
              <th className={'text-center py-3 font-semibold'}>Unit Price</th>
              <th className={'text-center py-3 font-semibold'}>Size</th>
              <th className={'text-center py-3 font-semibold'}>Quantity</th>
              <th className={'text-right py-3 font-semibold'}>Total</th>
            </tr>
          </thead>
          <tbody>
            {orderSummary?.products?.map((item, index) => (
              <tr key={index} className={'border-b'}>
                <td className={'py-4 text-gray-800'}>{item?.productName}</td>
                <td className={'py-4 text-center text-gray-800'}>₹{item.pricePerUnit}</td>
                <td className={'py-4 text-center text-gray-800'}>  {item?.size?.[0]?.size}</td>
                <td className={'py-4 text-center text-gray-800'}>{item?.size?.[0]?.quantity}</td>
                <td className={'py-4 text-right text-gray-800'}>
                    ₹{item.pricePerUnit * item.quantity}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        
        <div className={'flex justify-end'}>
          <div className={'w-full sm:w-1/2 lg:w-1/3'}>
            {/* <div className={'flex justify-between py-2 text-sm text-gray-700'}>
              <span>Subtotal</span>
              <span> ₹{
                orderSummary?.items?.reduce((sum, item) => {
                  return sum + (item?.pricePerUnit * item?.quantity);
                }, 0)
              }</span>
            </div> */}
            <div className={'flex justify-between py-2 text-sm text-gray-700'}>
              <span>Delivery Charges</span>
              <span>₹{orderSummary?.
                deliveryCharges || 0}</span>
            </div> 
            {/* <div className={'flex justify-between py-2 text-sm text-gray-700'}>
              <span>Packaging Charges</span>
              <span>₹{orderSummary?.packagingCharges}</span>
            </div> */}
            <div className={'mt-3 pt-3 flex justify-between text-base font-bold text-gray-900'}>
              <span>Amount :</span><span>₹{Number(orderSummary.totalAmount)}</span>
            </div>

          </div>

        </div>
        <div className={'text-right mt-6'}>
          <p className={'text-lg font-semibold text-gray-700'}>RatnaParki Jewellers</p>
          <p className={'text-sm text-gray-500'}>+91 9371100954</p>
        </div>
        
        <div className={'mt-10 text-center'}>
          <p className={'text-md text-gray-500 italic font-light'}>
              - Thanks for shopping with us -
          </p>
        </div>
      </div>
    </div>

  );
};

InvoiceScreen.propTypes = {
  selectedOrderSummary: PropTypes.object,
  setSelectedOrderSummary: PropTypes.func,
  setOpenInvoiceModal: PropTypes.func,
};

export default InvoiceScreen;
